/* eslint-disable @typescript-eslint/naming-convention */
import apiService from 'config/apiServiceApiGateway'
import * as oldApiService from 'config/apiServiceConfig'
import { PackageIdItemType, PackageIdDetailItemType } from '../@types/GeneratePackageId'
import { GeneratePackageIdFormType } from '../pages/GeneratePackageId/schema'

export type GetPackageIdParamsType = {
  'pagination.page_index': number
  'pagination.page_size': number
  date?: string
  package_label?: string
}

type GetPackageIdResponseType = {
  data: PackageIdItemType[]
  pagination: {
    direction: string
    page_index: number
    page_size: number
    sort: string
  }
}

type GetPackageIdDetailResponseType = {
  data: PackageIdDetailItemType[]
  pagination: {
    direction: string
    page_index: number
    page_size: number
    sort: string
  }
}

export type PostGeneratePackageIdResponseType = {
  data: {
    packageId: number
    packageLabel: string
    createdDateTime: number
    inputMethod: Nullable<string>
    rack: Nullable<string>
  }[]
}

export const getPackageIdListApi = (params: GetPackageIdParamsType) =>
  apiService.Get<GetPackageIdResponseType, true>({
    url: '/wims/internal/v1/package-ids',
    params,
  })

export const postGeneratePackageIdApi = (data: GeneratePackageIdFormType) =>
  oldApiService.Post<PostGeneratePackageIdResponseType>({
    url: '/api/package-id',
    data,
  })

export const getPackageIdDetailApi = (date: string, params: GetPackageIdParamsType) =>
  apiService.Get<GetPackageIdDetailResponseType, true>({
    url: '/wims/internal/v1/package-ids/:date/details',
    urlParams: { date },
    params,
  })
